import React, { Component, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography'
import { withStyles, transitions } from '@material-ui/core/styles';
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import GoogleMapReact from 'google-map-react';
import {withRouter} from "react-router-dom";
import {blue, red, yellow, green} from '@material-ui/core/colors'
import { fitBounds } from 'google-map-react/utils';
import { observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { pending } from '../stores/State';
import Map from '@material-ui/icons/Map';
import Polyline from './Polyline';

const GoogleAPIKey = 'AIzaSyApXL_amNeE46hYHT-bryVcyj0sxEQyOBA';
const MAP_HEIGHT = 500;
const DEFAULT_CENTER = {lat: 60.192059, lng: 	24.945831};
const DEFAULT_ZOOM = 10;
const Marker = ({ backgroundColor, borderColor, text }) => {

  return (
  <div style={
    {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 20,
      height: 20,
      backgroundColor: backgroundColor || blue[800],
      borderColor: borderColor || blue[200],
      borderWidth: 2,
      borderStyle: 'solid',
      borderRadius: '50%',
      color: 'white',
      transform: 'translate(-50%,-50%)'
    }}>
      <span>{text}</span>
    </div> 
)};

@inject('store')
@observer
class InventoryTransactionsMap extends Component {

  @observable defaultCenter = DEFAULT_CENTER
  @observable defaultZoom = DEFAULT_ZOOM
  @observable center = DEFAULT_CENTER
  @observable zoom = DEFAULT_ZOOM
  mapContainerElement = undefined


  constructor() {
    super();
    this.state = {
      mapLoaded: false
    }
  }
  componentDidMount(){
    this.reactionHandler = reaction(()=>this.props.store.transactionStore.transactions, (transactions)=>{
      this.updateDefaultBounds();
    })
  }

  componentWillUnmount(){
    this.reactionHandler();
  }
  
  updateDefaultBounds(){
    const store = this.props.store.transactionStore;
    if(!store.transactions) return;
    
    const locations = store.transactions.results.filter(transaction=>_.get(transaction, 'location.coordinates')).map(transaction=>transaction.location);

    if(!locations.length){
      this.center = DEFAULT_CENTER;
      this.zoom = DEFAULT_ZOOM;
      return
    }
    else if(locations.length == 1){
      this.center = {lat: locations[0].coordinates.coordinates[1], lng: locations[0].coordinates.coordinates[0]};
      this.zoom = DEFAULT_ZOOM;
      return
    }

    const latitudes = locations.map(location=>location.coordinates.coordinates[1]).sort();
    const longitudes = locations.map(location=>location.coordinates.coordinates[0]).sort();
    
    const bounds = {
      ne: {
        lat: _.last(latitudes),
        lng: _.last(longitudes)
      },
      sw: {
        lat: _.first(latitudes),
        lng: _.first(longitudes)
      }
    };

    const size = {
      width: this.mapContainerElement ? this.mapContainerElement.clientWidth : 600, // Map height in pixels 
      height: MAP_HEIGHT, // Map width in pixels
    };

    const {center, zoom} = fitBounds(bounds, size);
    
    this.center = center;
    this.zoom = zoom-1;
  }

  handleRowClick(location){
    //this.props.history.push(`/inventory_locations/${location.id}`);    
  }

  renderMarkers(){
    const { classes, theme } = this.props;
    const { inventoryAlert } = theme;
    const  store  = this.props.store.transactionStore;
    
    if(!store.transactions) return null;
    return store.transactions.results.filter(transaction=>_.get(transaction, 'location.coordinates'))
    .map(transaction=>
        <Marker
        key={transaction.id}
        lat={transaction.location.coordinates.coordinates[1]}
        lng={transaction.location.coordinates.coordinates[0]}
        />
    );
  }
  renderPolylines(){
    const { classes, theme } = this.props;
    const  store  = this.props.store.transactionStore;
    
    if(!store.transactions) return null;
    const transactions = store.transactions.results.filter(transaction=>_.get(transaction, 'location.coordinates'));
    return transactions.map((transaction, index) => 
        (transactions.length > index + 1) && <Polyline color={blue[800]} map={this.state.map} maps={this.state.maps}
          key={transaction.id}
          origin={{lat: transaction.location.coordinates.coordinates[1], lng: transaction.location.coordinates.coordinates[0]}}
          destination={{lat: transactions[index+1].location.coordinates.coordinates[1], lng: transactions[index+1].location.coordinates.coordinates[0]}}
          />
      );
  }

  handleMarkerClick(key){
    //this.props.history.push(`/inventory_locations/${key}`);        
  }

  render() {
    const { classes } = this.props;
    const  store  = this.props.store.transactionStore;
    
    return (
      <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'>Map</Typography>
        { store.inventoryLocationsState === pending && <CircularProgress /> }
        <div className={classes.mapContainer} ref={ element=> this.mapContainerElement = element}>
          <GoogleMapReact
          bootstrapURLKeys={{ key: GoogleAPIKey}}
          className={classes.map}
          defaultCenter={this.defaultCenter}
          defaultZoom={this.defaultZoom}
          center={this.center}
          zoom={this.zoom}
          onChildClick={this.handleMarkerClick.bind(this)}
          onGoogleApiLoaded={({ map, maps }) => { this.setState({ map: map, maps:maps, mapLoaded: true }) }}
          yesIWantToUseGoogleMapApiInternals
          >
            {this.renderMarkers()}
          </GoogleMapReact>
          { this.state.mapLoaded && this.renderPolylines() }
        </div>
      </Paper>
    );
  }
}


const styles = theme => ({
  paper:{
    padding: 20
  },
  mapContainer:{
    height: MAP_HEIGHT,
    marginTop: 10  
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

InventoryTransactionsMap.propTypes = {
  customerId: PropTypes.number,
}

export default withRouter(withStyles(styles, {withTheme: true})(InventoryTransactionsMap));



// WEBPACK FOOTER //
// ./src/components/InventoryTransactionsMap.js